import Vue from 'vue';
import Vuex from 'vuex';
import mainActions from './actions';
import mainMutations from './mutations';
import mainGetters from './getters';
import mainState from './state';

Vue.use(Vuex);

function factory ({ state = {}, actions = {}, mutations = {}, getters = {} }) {
  state = Object.assign(mainState, state);
  actions = Object.assign(mainActions, actions);
  mutations = Object.assign(mainMutations, mutations);
  getters = Object.assign(mainGetters, getters);

  return new Vuex.Store({
    state,
    actions,
    mutations,
    getters,
  });
}

export default factory;
